// tslint:disable
/**
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */


import type { AxiosInstance, AxiosResponse, AxiosRequestConfig, AxiosRequestHeaders } from 'axios';
import axios from 'axios';
import FormData from 'form-data';
import { Moment } from 'moment';
import { Inject, Scoped } from 'vue-di';

/* tslint:disable:no-unused-locals */
import {
    Serializer,
    UNKNOWN_BASE_TYPE,
    DocumentCreateModel,
    DocumentLongResponse,
    DocumentModelResponse,
    DocumentPdfDocumentModel,
    LongDocumentDocumentCreateModelResponse,
} from '@trialcard/apigateway.models';
import { Authentication, ApiKeyAuth, OAuth, OAuthTokenProvider, NullAuthTokenProvider, OAUTH_TOKEN_PROVIDER } from '@trialcard/authentication';
import * as enums from '@trialcard/enums';
import {
    createAxiosHeaders,
    EntLibServiceClient,
    RequestFile,
    X_TC_USERID,
    ConfigureWith,
    SetPackageName,
} from '@trialcard/shared';
import { AXIOS, AUDIENCE, BASE_PATH } from './symbols.js';
import { configure } from './configure.js';

// ===============================================
// This file is autogenerated - Please do not edit
// ===============================================

@Scoped
@ConfigureWith(configure)
@SetPackageName('@trialcard/apigateway.client')
export class DocumentV3Api extends EntLibServiceClient {
    protected authentications: {
        'Token': Authentication;
        'UserId': ApiKeyAuth;
    }

    public constructor(
        @Inject(AXIOS) private readonly axios: AxiosInstance,
        @Inject(X_TC_USERID) xTcUserId: string,
        @Inject(AUDIENCE) audience: string,
        @Inject(BASE_PATH) url: string,
        @Inject(OAUTH_TOKEN_PROVIDER) tokenProvider: OAuthTokenProvider) {
        super();
        this.authentications = {
            'Token': new OAuth({ name: 'apigateway', url, audience }, tokenProvider),
            'UserId': new ApiKeyAuth('header', 'x-tc-userid'),
        };

        if ((this.authentications as any).UserId) {
            (this.authentications as any).UserId.apiKey = xTcUserId;
        }
    }

    /**
     * 
     * @summary Creates a new Document.
     * @param documentCreateModel Document Create Model object
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async documentCreateByProgramId (documentCreateModel: DocumentCreateModel, xProgramId?: number): Promise<AxiosResponse<LongDocumentDocumentCreateModelResponse>> {
        const _url_ = '/document/v3/Document';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'documentCreateModel' is not null or undefined
        if (documentCreateModel === null || documentCreateModel === undefined) {
            throw new Error('Required parameter documentCreateModel was null or undefined when calling documentCreateByProgramId.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "number");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(documentCreateModel, "DocumentCreateModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<LongDocumentDocumentCreateModelResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "LongDocumentDocumentCreateModelResponse");
        }
        return response;
    }
    /**
     * 
     * @summary Get a Document by Document identifier.
     * @param documentId Document identifier.
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async documentGetByProgramId (documentId: number, xProgramId?: number): Promise<AxiosResponse<DocumentModelResponse>> {
        const _url_ = '/document/v3/Document/{documentId}'
            .replace('{' + 'documentId' + '}', encodeURIComponent(String(documentId)));
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'documentId' is not null or undefined
        if (documentId === null || documentId === undefined) {
            throw new Error('Required parameter documentId was null or undefined when calling documentGetByProgramId.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "number");

        const requestConfig: AxiosRequestConfig = {
            method: 'GET',
            params: _params_,
            headers: _headers_,
            url: _url_,
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<DocumentModelResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DocumentModelResponse");
        }
        return response;
    }
    /**
     * 
     * @summary Creates a new Document.
     * @param documentPdfDocumentModel InsertDocumentRequestModel object
     * @param xProgramId The program id from the list of allowed program ids
     */
    public async pdfDocumentCreateByProgramId (documentPdfDocumentModel: DocumentPdfDocumentModel, xProgramId?: number): Promise<AxiosResponse<DocumentLongResponse>> {
        const _url_ = '/document/v3/PdfDocument';
        const _params_: any = {};
        const _headers_: AxiosRequestHeaders = createAxiosHeaders();

        // verify required parameter 'documentPdfDocumentModel' is not null or undefined
        if (documentPdfDocumentModel === null || documentPdfDocumentModel === undefined) {
            throw new Error('Required parameter documentPdfDocumentModel was null or undefined when calling pdfDocumentCreateByProgramId.');
        }

        _headers_['x-program-id'] = Serializer.serialize(xProgramId, "number");

        const requestConfig: AxiosRequestConfig = {
            method: 'POST',
            params: _params_,
            headers: _headers_,
            url: _url_,
            data: Serializer.serialize(documentPdfDocumentModel, "DocumentPdfDocumentModel"),
        };

        await Promise.all([
            this.authentications['Token'].applyToRequest(requestConfig),
        ]);

        const response = await this.axios.request<DocumentLongResponse>(requestConfig);

        if (response.status && response.status >= 200 && response.status <= 299) {
            response.data = Serializer.deserialize(response.data, "DocumentLongResponse");
        }
        return response;
    }
}
